if (!customElements.get('mobile-sliderule')) {
  customElements.define(
    'mobile-sliderule',

    class HeaderMobileSliderule extends HTMLElement {
      constructor() {
        super();

        this.key = this.id;
        this.menuBlock = this.closest('[data-mobile-menu-block]');
        this.sliderule = this.querySelector('[data-sliderule]');
        const btnSelector = `[data-sliderule-open='${this.key}']`;
        this.exitSelector = `[data-sliderule-close='${this.key}']`;
        this.trigger = this.querySelector(btnSelector);
        this.exit = document.querySelectorAll(this.exitSelector);
        this.pane = this.trigger.closest('[data-sliderule-pane]');
        this.childrenElements = this.querySelectorAll(`:scope > [data-animates],
           :scope > * > [data-animates],
           :scope > * > * > [data-animates],
           :scope > * > .sliderule-grid  > *`);
        this.drawerContent = this.closest('[data-drawer-content]');
        this.cachedButton = null;
        this.a11y = window.theme.a11y;

        this.trigger.setAttribute('aria-haspopup', true);
        this.trigger.setAttribute('aria-expanded', false);
        this.trigger.setAttribute('aria-controls', this.key);
        this.closeSliderule = this.closeSliderule.bind(this);

        this.clickEvents();
        this.keyboardEvents();

        document.addEventListener('theme:sliderule:close', this.closeSliderule);
      }

      connectedCallback() {
        // Set initial height for menu block (required for CSS transition)
        requestAnimationFrame(() => {
          if (this.menuBlock && !this.menuBlock.style.getPropertyValue('--block-height')) {
            this.menuBlock.style.setProperty('--block-height', `${this.menuBlock.scrollHeight}px`);
          }
        });
      }

      clickEvents() {
        this.trigger.addEventListener('click', () => {
          this.cachedButton = this.trigger;
          this.showSliderule();
        });
        this.exit.forEach((element) => {
          element.addEventListener('click', () => {
            this.hideSliderule();
          });
        });
      }

      keyboardEvents() {
        this.addEventListener('keyup', (evt) => {
          evt.stopPropagation();
          if (evt.code !== 'Escape') {
            return;
          }

          this.hideSliderule();
        });
      }

      adjustMenuHeight() {
        if (!this.menuBlock) return;

        const visiblePanel = this.menuBlock.querySelector('[data-sliderule="2"].is-visible') || this.menuBlock.querySelector('[data-sliderule="1"].is-visible') || this.menuBlock;
        const linksContainer = visiblePanel.querySelector('[data-links]');

        this.menuBlock.style.setProperty('--block-height', `${linksContainer.scrollHeight}px`);
      }

      trapFocusSliderule(showSliderule = true) {
        const trapFocusButton = showSliderule ? this.querySelector(this.exitSelector) : this.cachedButton;

        this.a11y.removeTrapFocus();

        if (trapFocusButton && this.drawerContent) {
          this.a11y.trapFocus(this.drawerContent, {
            elementToFocus: document.body.classList.contains('is-focused') ? trapFocusButton : null,
          });
        }
      }

      hideSliderule(close = false) {
        const newPosition = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
        this.pane.setAttribute('data-sliderule-pane', newPosition);
        this.pane.classList.add('is-hiding');
        this.sliderule.classList.add('is-hiding');
        const hiddenSelector = close ? `[data-animates].is-hidden` : `[data-animates="${newPosition}"]`;
        const hiddenItems = this.pane.querySelectorAll(hiddenSelector);
        hiddenItems?.forEach((element) => {
          element.classList.remove('is-hidden');
        });

        const children = close ? this.pane.querySelectorAll('.is-visible, .is-hiding') : this.childrenElements;
        const childrenLength = children.length;
        children.forEach((element, index) => {
          const lastElement = index === childrenLength - 1;
          element.classList.remove('is-visible');
          if (close) {
            element.classList.remove('is-hiding');
            this.pane.classList.remove('is-hiding');
          }
          const removeHidingClass = () => {
            if (parseInt(this.pane.getAttribute('data-sliderule-pane')) === newPosition) {
              this.sliderule.classList.remove('is-visible');
            }
            this.sliderule.classList.remove('is-hiding');
            this.pane.classList.remove('is-hiding');

            if (lastElement) {
              this.a11y.removeTrapFocus();
              if (!close) {
                this.trapFocusSliderule(false);
              }
              requestAnimationFrame(() => {
                this.adjustMenuHeight();
              });
            }

            element.removeEventListener('animationend', removeHidingClass);
          };

          if (window.theme.settings.enableAnimations) {
            element.addEventListener('animationend', removeHidingClass);
          } else {
            removeHidingClass();
          }
        });
      }

      showSliderule() {
        let lastScrollableFrame = null;
        const parent = this.closest('.is-visible');
        const lastScrollableElement = parent || this.pane;

        lastScrollableElement.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });

        lastScrollableElement.classList.add('is-scrolling');

        const lastScrollableIsScrolling = () => {
          if (lastScrollableElement.scrollTop <= 0) {
            lastScrollableElement.classList.remove('is-scrolling');
            if (lastScrollableFrame) {
              cancelAnimationFrame(lastScrollableFrame);
            }
          } else {
            lastScrollableFrame = requestAnimationFrame(lastScrollableIsScrolling);
          }
        };

        lastScrollableFrame = requestAnimationFrame(lastScrollableIsScrolling);

        const oldPosition = parseInt(this.pane.dataset.sliderulePane, 10);
        const newPosition = oldPosition + 1;
        this.sliderule.classList.add('is-visible');
        this.pane.setAttribute('data-sliderule-pane', newPosition);

        requestAnimationFrame(() => {
          this.adjustMenuHeight();
        });

        const hiddenItems = this.pane.querySelectorAll(`[data-animates="${oldPosition}"]`);
        const hiddenItemsLength = hiddenItems.length;
        hiddenItems?.forEach((element, index) => {
          const lastElement = index === hiddenItemsLength - 1;
          element.classList.add('is-hiding');
          const removeHidingClass = () => {
            element.classList.remove('is-hiding');
            if (parseInt(this.pane.getAttribute('data-sliderule-pane')) !== oldPosition) {
              element.classList.add('is-hidden');
            }

            if (lastElement) {
              this.trapFocusSliderule();
            }
            element.removeEventListener('animationend', removeHidingClass);
          };

          if (window.theme.settings.enableAnimations) {
            element.addEventListener('animationend', removeHidingClass);
          } else {
            removeHidingClass();
          }
        });
      }

      closeSliderule() {
        if (this.pane && this.pane.hasAttribute('data-sliderule-pane') && parseInt(this.pane.getAttribute('data-sliderule-pane')) > 0) {
          this.hideSliderule(true);
          if (parseInt(this.pane.getAttribute('data-sliderule-pane')) > 0) {
            this.pane.setAttribute('data-sliderule-pane', 0);
          }
          requestAnimationFrame(() => {
            this.adjustMenuHeight();
          });
        }
      }

      disconnectedCallback() {
        document.removeEventListener('theme:sliderule:close', this.closeSliderule);
      }
    }
  );
}
